<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form v-show="!showSkeleton" ref="form">
      <div class="text-h4 mb-7" v-if="edicao === 'false' || !edicao">
        Cadastro de Grupo de Ramal
      </div>
      <v-row dense>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Descrição do Grupo"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-select
            dense
            v-model="form.strategy"
            :error-messages="strategyErrors"
            :items="estrategia"
            item-value="value"
            item-text="text"
            outlined
            label="Estratégia"
            hint="Escolha a estratégia"
            persistent-hint
            @input="$v.form.strategy.$touch()"
            @blur="$v.form.strategy.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-text-field
            dense
            v-model="form.time"
            :error-messages="timeErrors"
            :counter="2"
            type="number"
            label="Tempo (segundos)"
            outlined
            @input="
              $v.form.time.$touch()
              form.time = $event.trim()
            "
            @blur="$v.form.time.$touch()"
          />
        </v-col>
      </v-row>
      <div class="mr-4">
        <DraggAndDrop
          dragname="Ramais"
          :valoresDisponiveisComboBox="ramais.ramaisDisponiveis"
          @dragUpdate="updateCodecs($event)"
          :opcoes-selecionadas="ramais.ramaisSelecionadas"
        />
      </div>

      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <v-divider dark />

      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'
import { ordenar } from '@/utils/ordenarArrayByText'

import gruposRamaisStore from '../_store'
import { validateData, validateComputed } from '../_validates'
import GruposRamaisHttpService from '../_services/GruposRamaisHttpService'
import DraggAndDrop from '../_components/DraggAndDrop'

export default {
  name: 'CadastroGrupoRamal',
  props: {
    edicao: String,
    _id: String,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },
  mixins: [validationMixin],
  data: () => ({
    form: {
      description: '',
      strategy: '',
      ramais: [],
      time: 20,
      tipo: 'GRUPOATENDIMENTO',
    },
    estrategia: [
      { text: 'Aleatoriamente', value: 'random' },
      { text: 'Atendeu menos chamadas', value: 'fewestcalls' },
      { text: 'Disponível por mais tempo', value: 'leastrecent' },
      { text: 'Ordenado', value: 'rrordered' },
      { text: 'Primeiro ramal livre da sequência', value: 'linear' },
      { text: 'Sequência definida pelo usuário', value: 'rrmemory' },
      { text: 'Tocar todos', value: 'ringall' },
    ],
    ramais: {
      ramaisDisponiveis: [],
      ramaisSelecionadas: [],
    },
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('cadastroGrupoRamaisModulePABXStore', ['getGrupoRamalSelecionado', 'getRamais']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'cadastroGrupoRamaisModulePABXStore', gruposRamaisStore)

    await this.listarRamais()

    this.ramais.ramaisDisponiveis = this.getRamais.ramais.map(ramal => ({
      description: `${ramal.numero} - ${ramal.usuario}`,
      value:`${ramal.numero}`,
      }))
    // this.ramais.ramaisDisponiveis = this.getRamais.ramais.map(ramal => `${ramal.numero}`)
    

    if (this.edicao === 'true') {
      this.form = this.getGrupoRamalSelecionado

      // this.ramais.ramaisSelecionadas = [...this.form.ramais]
      this.form.ramais.forEach(operador => {
        this.getRamais.ramais.forEach(ramal => {
          if (ramal.numero == operador) {
            this.ramais.ramaisSelecionadas.push({
              description: `${ramal.numero} - ${ramal.usuario}`,
              value: `${ramal.numero}`,
            })
          }
        })
      })
      

      // this.form.ramais.forEach(ramal => {
      //   this.ramais.ramaisDisponiveis.splice(this.ramais.ramaisDisponiveis.indexOf(ramal), 1)
      // })
    }

    ordenar(this.ramais.ramaisDisponiveis)
    this.showSkeleton = false
  },

  methods: {
    ...mapActions('cadastroGrupoRamaisModulePABXStore', ['listarRamais']),

    updateCodecs(event) {
      // if(typeof(event) == 'object'){
        this.form.ramais = event.map(object => object.value)
      // }else{
        // this.form.ramais = event
      // }
    },

    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        if (this.edicao === 'true') { 
          await GruposRamaisHttpService.putGrupoRamal(this.form)
        } else {
          await GruposRamaisHttpService.postGrupoRamal(this.form)
        }
        this.$router.push({ name: 'GruposRamais' })
      } catch (error) {
        this.text = error.response.data
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'GruposRamais' })
    },
  },
}
</script>
